/** MARC heading tags, in the order `AlephFormat.detect` checks them. */
var HEADING_TAGS = ['100', '110', '111', '130', '148', '150', '151', '155'];
/**
 * A stable key for the derivation inputs of `fields`.
 *
 * @param fields the record as the preview has it (form-derived rows plus whatever
 *               control fields the caller already knows about)
 * @returns a short string; equal strings mean the derived control fields are equal
 */
export var derivedControlFieldSignature = function (fields) {
    var _a, _b, _c, _d;
    var heading = (_a = HEADING_TAGS.find(function (tag) { return fields.some(function (f) { return f.fieldTag === tag; }); })) !== null && _a !== void 0 ? _a : '-';
    var headingHasT = fields.some(function (f) { return f.fieldTag === heading && f.subfields.some(function (sf) { return sf.subfieldCode === 't' && !!sf.value; }); });
    var rda = fields.some(function (f) { return f.fieldTag === '040'
        && f.subfields.some(function (sf) { var _a; return sf.subfieldCode === 'e' && ((_a = sf.value) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'rda'; }); });
    var value950a = (_d = (_c = (_b = fields
        .find(function (f) { return f.fieldTag === '950'; })) === null || _b === void 0 ? void 0 : _b.subfields.find(function (sf) { return sf.subfieldCode === 'a'; })) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '';
    var has008 = fields.some(function (f) { return f.fieldTag === '008'; });
    return [heading, headingHasT ? 't' : '-', rda ? 'rda' : '-', value950a, has008 ? '008' : '-']
        .join('|');
};
